import React from "react";

const startIcon = props => (
  <svg width={10} height={16} {...props}>
    <title>{"read_from_here"}</title>
    <path
      d="M7.118 5.861L3.88 7.803a.323.323 0 0 1-.49-.277V3.64a.324.324 0 0 1 .49-.277l3.238 1.943a.322.322 0 0 1 0 .555M4.833.75C2.165.75 0 2.978 0 5.727c0 2.238 3.208 7.435 4.397 9.284a.518.518 0 0 0 .873 0c1.189-1.849 4.397-7.046 4.397-9.284C9.667 2.978 7.503.75 4.833.75"
      fill="#007FAD"
      fillRule="evenodd"
    />
  </svg>
);

export default startIcon;
